import { render } from "./ProductCodeGen.vue?vue&type=template&id=371d43f8&scoped=true"
import script from "./ProductCodeGen.vue?vue&type=script&lang=js"
export * from "./ProductCodeGen.vue?vue&type=script&lang=js"

import "./ProductCodeGen.vue?vue&type=style&index=0&id=371d43f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371d43f8"]])

export default __exports__